"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var process_dto_1 = require("../model/process.dto");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var http_1 = require("@angular/common/http");
var process_structure_dto_1 = require("../model/process-structure.dto");
/**
 * Dummy implementation of ProcessService
 */
var DummyProcessService = /** @class */ (function () {
    function DummyProcessService(http, applicationPropertiesService) {
        var _this = this;
        this.http = http;
        /**
         * Key for getting processes' json file
         * @type {string}
         */
        this.processApiUrlKey = 'workflow-processes-service-url';
        this.processMap = new Map();
        this.dataLoaded = new Promise(function (resolve) {
            applicationPropertiesService
                .getProperty(_this.processApiUrlKey)
                .then(function (url) {
                http.get(url).toPromise().then(function (response) {
                    var processes = _this.extractProcesses(response);
                    processes.forEach(function (process) { return _this.processMap.set(process.getId(), process); });
                    resolve(true);
                });
            })
                .catch(DummyProcessService_1.handleError);
        });
    }
    DummyProcessService_1 = DummyProcessService;
    /**
     * Get all processes
     * @returns {Promise<Array<ProcessDto>>}
     */
    DummyProcessService.prototype.getProcesses = function () {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var processes = [];
                Array.from(_this.processMap).forEach(function (element) { return processes.push(element[1]); });
                resolve(processes);
            });
        });
    };
    DummyProcessService.prototype.getProcessesWithTrackInfo = function () {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var processes = [];
                Array.from(_this.processMap).forEach(function (element) { return processes.push(element[1]); });
                resolve(processes);
            });
        });
    };
    /**
     * Get process by id
     * @param id
     * @returns {Promise<ProcessDto>}
     */
    DummyProcessService.prototype.getProcessById = function (id) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var process = _this.processMap.get(id);
                resolve(new process_dto_1.ProcessDto(process.getId(), process.getNameMap(), process.getInitialStateId(), process.getCategorySystemName()));
            });
        });
    };
    DummyProcessService.prototype.getStructure = function (id) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var workflow = _this.processMap.get(id);
                resolve(workflow);
            });
        });
    };
    /**
     * Save process
     * @param process
     * @returns {Promise<number>} saved process's id
     */
    DummyProcessService.prototype.save = function (process) {
        var t = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var size = t.processMap.size;
                t.processMap.set(size + 1, process);
                resolve(size + 1);
            });
        });
    };
    /**
     * Update the given process
     * @param id process's id which is going to be updated
     * @param process
     * @returns {Promise<number>} updated process id
     */
    DummyProcessService.prototype.update = function (id, process) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                _this.processMap.set(id, process);
                resolve(id);
            });
        });
    };
    DummyProcessService.prototype.patchUpdate = function (id, process) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve, reject) {
                var current = _this.processMap.get(id);
                if (current) {
                    _this.processMap.set(id, new process_structure_dto_1.ProcessStructureDto(process.getId(), process.getNameMap(), process.getInitialStateId(), process.getCategorySystemName(), current.getModifiedBy(), current.getModifiedOn(), current.getStates(), current.getActions(), current.getLayout(), current.getInitialStateIndex()));
                    resolve(id);
                }
                else {
                    reject("Process " + id + " not found");
                }
            });
        });
    };
    DummyProcessService.prototype.delete = function (id) {
        var _this = this;
        return this.dataLoaded.then(function (loaded) {
            return new Promise(function (resolve) {
                var deleted = _this.processMap.delete(id);
                resolve(deleted);
            });
        });
    };
    /**
     * Get processes from response json
     * @param data
     */
    DummyProcessService.prototype.extractProcesses = function (data) {
        return data.reduce(function (acc, item) {
            var process = DummyProcessService_1.createProcessDto(item);
            acc.push(process);
            return acc;
        }, []);
    };
    DummyProcessService.createProcessDto = function (item) {
        var processId = Number(item.id);
        var name = DummyProcessService_1.convertObjectToMap(item.name);
        var initialStateId = Number(item.initialStateId);
        var categorySystemName = item.categorySystemName;
        return new process_dto_1.ProcessDto(processId, name, initialStateId, categorySystemName);
    };
    DummyProcessService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var prop = _a[_i];
            strMap.set(Number(prop), obj[prop]);
        }
        return strMap;
    };
    /**
     * Handle errors
     */
    DummyProcessService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    DummyProcessService = DummyProcessService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], DummyProcessService);
    return DummyProcessService;
    var DummyProcessService_1;
}());
exports.DummyProcessService = DummyProcessService;
//# sourceMappingURL=dummy-process.service.js.map